// Nofollow attribute helper
export const getRelAttributes = (nofollow?: boolean): string | undefined => {
  return nofollow ? 'nofollow' : undefined;
};

export const variantClasses = {
  primary:
    'bg-brand-700 text-white hover:bg-brand-600 active:bg-brand-800 justify-center',
  secondary:
    'border border-brand-400 bg-white text-neutral-900 justify-center hover:bg-powder-blue active:bg-cloud-whisper disabled:bg-neutral-0 disabled:text-neutral-300 disabled:border-neutral-300',
  tertiary:
    'bg-transparent border-none text-neutral-900 !p-0.5 hover:underline hover:underline-offset-4 hover:text-neutral-700 disabled:text-neutral-300 disabled:no-underline',
  destructive: 'bg-red-100 text-white hover:bg-red-200 active:bg-red-300',
  success: 'bg-green-100 text-white hover:bg-green-200 active:bg-green-300',
};

export const themeVariantClasses = {
  primary: 'bg-white text-neutral-900 active:bg-white justify-center',
  secondary:
    'border border-ocean-mist bg-white text-neutral-900 justify-center hover:bg-powder-blue active:bg-cloud-whisper disabled:bg-neutral-0 disabled:text-neutral-300 disabled:border-neutral-300',
  tertiary:
    'bg-transparent border-none text-white hover:underline !p-0.5 hover:underline-offset-4 disabled:text-neutral-300 disabled:no-underline',
  destructive: 'bg-red-100 text-white hover:bg-red-200 active:bg-red-300',
  success: 'bg-green-100 text-white hover:bg-green-200 active:bg-green-300',
};

// Disabled class utility (disable visual focus and click events for disabled links)
export const disabledClasses =
  'cursor-not-allowed !text-neutral-300 bg-neutral-0 pointer-events-none';

export const sizeClasses = {
  small: 'px-[18px] py-2',
  medium: 'px-[18px] py-3',
  large: 'px-[18px] py-4',
};
